/*
 * - Stores paths for the dashboard service endpoints
 */

const serviceRoot = 'api/dashboard/';

export const DashboardEndpoints = {
  // Queries ---------------------------------------------------------------------------------------
  getUserRequests: () => `${serviceRoot}getUserProjects`,
  getRegulatorHelpRequests: () => `${serviceRoot}regulator`,

  // Mutations -------------------------------------------------------------------------------------
  cancelRequest: () => `${serviceRoot}cancelProject`,
  withdrawRequest: () => `${serviceRoot}withdrawProject`,
};
